import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
} from '@mui/material';
import { ToastContainer } from 'react-toastify';

const EditCertificateDialog = ({ open, onClose, onSave, certificate: initialCertificate }) => {
    const [certificate, setCertificate] = useState({
        name: '',
        issuingOrganization: '',
        issueDate: '',
        skills: '',
        links: '',
    });

    // Initialize form with certificate data when dialog opens
    useEffect(() => {
        if (open && initialCertificate) {
            setCertificate({
                ...initialCertificate,
                // Convert arrays back to comma-separated strings for the form
                skills: Array.isArray(initialCertificate.skills)
                    ? initialCertificate.skills.join(',')
                    : initialCertificate.skills || '',
                links: Array.isArray(initialCertificate.links)
                    ? initialCertificate.links.join(',')
                    : initialCertificate.links || '',
                // Format dates for input[type="date"]
                issueDate: initialCertificate.issueDate ?
                    new Date(initialCertificate.issueDate).toISOString().split('T')[0] : '',
            });
        }
    }, [open, initialCertificate]);

    const handleCertificateChange = (e) => {
        const { name, value } = e.target;
        setCertificate((prev) => ({ ...prev, [name]: value }));
    };

    const handleSave = () => {
        // Pass ID from the original certificate to maintain reference
        onSave({ ...certificate, _id: initialCertificate._id });
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>Edit Certificate</DialogTitle>
            <DialogContent>
                <TextField
                    fullWidth
                    label="Certificate Name"
                    name="name"
                    value={certificate.name}
                    onChange={handleCertificateChange}
                    margin="normal"
                    required
                />
                <TextField
                    fullWidth
                    label="Issuing Organization"
                    name="issuingOrganization"
                    value={certificate.issuingOrganization}
                    onChange={handleCertificateChange}
                    margin="normal"
                />
                <TextField
                    fullWidth
                    label="Issue Date"
                    name="issueDate"
                    type="date"
                    value={certificate.issueDate}
                    onChange={handleCertificateChange}
                    margin="normal"
                    InputLabelProps={{ shrink: true }}
                />
                <TextField
                    fullWidth
                    label="Skills"
                    name="skills"
                    value={certificate.skills}
                    onChange={handleCertificateChange}
                    margin="normal"
                    placeholder="Add skills separated by commas"
                />
                <TextField
                    fullWidth
                    label="Links"
                    name="links"
                    value={certificate.links}
                    onChange={handleCertificateChange}
                    margin="normal"
                    placeholder="Add certificate links separated by commas"
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>
                    Cancel
                </Button>
                <Button onClick={handleSave} color="primary" variant="contained">
                    Save Changes
                </Button>
            </DialogActions>
            <ToastContainer
                position='bottom-center'
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </Dialog>
    );
};

export default EditCertificateDialog;